// Utilidades para los formularios DGII (IT-1 / Anexo A)

export const parseNum = (v) => {
  if (v === null || v === undefined || v === "") return 0;
  const n = parseFloat(String(v).replace(/,/g, ""));
  return isNaN(n) ? 0 : n;
};

export const fmtNum = (n) => {
  const num = typeof n === "number" ? n : parseNum(n);
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// Recalcula las casillas de totales del IT-1 según las fórmulas de la DGII
export const recalcularIT1 = (d) => {
  const g = (k) => parseNum(d[k]);
  const r = { ...d };

  // II. Ingresos
  r.cas009 = fmtNum(g("cas002") + g("cas003") + g("cas004") + g("cas005") + g("cas006") + g("cas007") + g("cas008"));
  r.cas010 = fmtNum(g("cas001") - parseNum(r.cas009));

  // ITBIS cobrado por tasa
  r.cas016 = fmtNum(g("cas011") * 0.18);
  r.cas017 = fmtNum(g("cas012") * 0.16);
  r.cas018 = fmtNum(g("cas013") * 0.09);
  r.cas019 = fmtNum(g("cas014") * 0.08);
  r.cas020 = fmtNum(g("cas015") * 0.18);

  // III. Liquidación
  r.cas021 = fmtNum(parseNum(r.cas016) + parseNum(r.cas017) + parseNum(r.cas018) + parseNum(r.cas019) + parseNum(r.cas020));
  r.cas025 = fmtNum(g("cas022") + g("cas023") + g("cas024"));
  const dif2125 = parseNum(r.cas021) - parseNum(r.cas025);
  r.cas026 = fmtNum(dif2125 > 0 ? dif2125 : 0);
  r.cas027 = fmtNum(dif2125 < 0 ? -dif2125 : 0);
  const dif33 = parseNum(r.cas026) - g("cas028") - g("cas029") - g("cas030") - g("cas031") - g("cas032");
  r.cas033 = fmtNum(dif33 > 0 ? dif33 : 0);
  r.cas034 = fmtNum(dif33 < 0 ? -dif33 : 0);

  // V. Monto a pagar
  r.cas038 = fmtNum(parseNum(r.cas033) + g("cas135") + g("cas136") + g("cas037"));

  // A. ITBIS Retenido / Percibido
  r.cas041 = fmtNum(g("cas039") + g("cas040"));
  r.cas046 = fmtNum(g("cas044") + g("cas045"));
  r.cas049 = fmtNum(g("cas047") + g("cas048"));
  r.cas050 = fmtNum(parseNum(r.cas041) * 0.18);
  r.cas051 = fmtNum(g("cas042") * 0.18);
  r.cas052 = fmtNum(g("cas043") * 0.18 * 0.3);
  r.cas053 = fmtNum(g("cas044") * 0.18);
  r.cas054 = fmtNum(g("cas045") * 0.16);
  r.cas055 = fmtNum(parseNum(r.cas053) + parseNum(r.cas054));
  r.cas056 = fmtNum(g("cas047") * 0.18);
  r.cas057 = fmtNum(g("cas048") * 0.16);
  r.cas058 = fmtNum(parseNum(r.cas056) + parseNum(r.cas057));
  r.cas060 = fmtNum(parseNum(r.cas050) + parseNum(r.cas051) + parseNum(r.cas052) + parseNum(r.cas055) + parseNum(r.cas058) + g("cas059"));
  const dif62 = parseNum(r.cas060) - g("cas061");
  r.cas062 = fmtNum(dif62 > 0 ? dif62 : 0);
  r.cas063 = fmtNum(dif62 < 0 ? -dif62 : 0);

  // C. Monto a pagar (retenciones)
  r.cas067 = fmtNum(parseNum(r.cas062) + g("cas164") + g("cas165") + g("cas066"));

  // Total general
  r.cas068 = fmtNum(parseNum(r.cas038) + parseNum(r.cas067));

  return r;
};

// Recalcula las casillas de totales del Anexo A
export const recalcularAnexoA = (d) => {
  const g = (k) => parseNum(d[k]);
  const r = { ...d };

  // II. Total operaciones por tipo de NCF
  r.cas111 = fmtNum(g("cas101") + g("cas102") + g("cas103") - g("cas104") + g("cas105") + g("cas106") + g("cas107") + g("cas108") + g("cas109") - g("cas110"));

  // III. Total por tipo de venta
  r.cas119 = fmtNum(g("cas112") + g("cas113") + g("cas114") + g("cas115") + g("cas116") + g("cas117") + g("cas118"));

  // IV. Total por tipo de ingreso
  r.cas126 = fmtNum(g("cas120") + g("cas121") + g("cas122") + g("cas123") + g("cas124") + g("cas125"));

  // V. Total pagos computables
  r.cas133 = fmtNum(g("cas127") + g("cas128") + g("cas129") + g("cas130") + g("cas131") + g("cas132"));

  // VI. Constructoras
  r.cas037 = fmtNum(g("cas034") + g("cas035"));
  r.cas137 = fmtNum(g("cas134") + g("cas135") + g("cas136"));

  // VII. Comisionistas
  r.cas041 = fmtNum(g("cas039") + g("cas040"));
  r.cas141 = fmtNum(g("cas139") + g("cas140"));

  // IX. ITBIS Pagado - totales por fila (columna TOTAL)
  r.cas345 = fmtNum(g("cas045") + g("cas145") + g("cas245"));
  r.cas346 = fmtNum(g("cas046") + g("cas146") + g("cas246"));
  r.cas347 = fmtNum(g("cas047") + g("cas147") + g("cas247"));
  // Fila 48 - Total ITBIS no deducible (por columna)
  r.cas048 = fmtNum(g("cas045") + g("cas046") + g("cas047"));
  r.cas148 = fmtNum(g("cas145") + g("cas146") + g("cas147"));
  r.cas248 = fmtNum(g("cas245") + g("cas246") + g("cas247"));
  r.cas348 = fmtNum(parseNum(r.cas345) + parseNum(r.cas346) + parseNum(r.cas347));
  // Deducible
  r.cas349 = fmtNum(g("cas049") + g("cas149") + g("cas249"));
  r.cas350 = fmtNum(g("cas050") + g("cas150") + g("cas250"));
  r.cas351 = fmtNum(g("cas051") + g("cas151") + g("cas251"));
  // Fila 52
  r.cas052 = fmtNum(g("cas049") + g("cas050") + g("cas051"));
  r.cas152 = fmtNum(g("cas149") + g("cas150") + g("cas151"));
  r.cas252 = fmtNum(g("cas249") + g("cas250") + g("cas251"));
  r.cas352 = fmtNum(parseNum(r.cas349) + parseNum(r.cas350) + parseNum(r.cas351));
  // Proporcionalidad
  const coef = g("cas154") / 100;
  r.cas055 = fmtNum(g("cas053") * coef);
  r.cas155 = fmtNum(g("cas153") * coef);
  r.cas255 = fmtNum(g("cas253") * coef);
  r.cas355 = fmtNum((g("cas053") + g("cas153") + g("cas253")) * coef);
  // Fila 56 - Total ITBIS deducible
  r.cas056 = fmtNum(parseNum(r.cas052) + parseNum(r.cas055));
  r.cas156 = fmtNum(parseNum(r.cas152) + parseNum(r.cas155));
  r.cas256 = fmtNum(parseNum(r.cas252) + parseNum(r.cas255));
  r.cas356 = fmtNum(parseNum(r.cas352) + parseNum(r.cas355));

  return r;
};

export const MESES = [
  "", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export const formatPeriodo = (p) => {
  if (!p || p.length < 6) return p || "";
  const ano = p.substring(0, 4);
  const mes = parseInt(p.substring(4, 6), 10);
  return `${MESES[mes] || ""} ${ano} (${ano}/${p.substring(4, 6)})`;
};
